const IconCopy = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.73331 2.09998C2.03139 2.09998 1.59998 2.72469 1.59998 3.31331V10.4866C1.59998 11.0753 2.03139 11.7 2.73331 11.7H4.59998V10.5H2.80075C2.80027 10.496 2.79998 10.4916 2.79998 10.4866V3.31331C2.79998 3.30839 2.80027 3.30395 2.80075 3.29998H9.5992L9.59977 3.30627L9.59998 3.31331V4.69998H10.8V3.31331C10.8 2.72469 10.3686 2.09998 9.66664 2.09998H2.73331ZM6.73331 5.69998C6.08014 5.69998 5.59998 6.24725 5.59998 6.85997V14.14C5.59998 14.7527 6.08014 15.3 6.73331 15.3H13.6666C14.3198 15.3 14.8 14.7527 14.8 14.14V6.85997C14.8 6.24725 14.3198 5.69998 13.6666 5.69998H6.73331ZM13.6 14.1H6.79998V6.89997H13.6V14.1ZM12.4 9.09998C12.4 9.43134 12.1313 9.69998 11.8 9.69998H8.59998C8.2686 9.69998 7.99998 9.43134 7.99998 9.09998C7.99998 8.7686 8.2686 8.49998 8.59998 8.49998H11.8C12.1313 8.49998 12.4 8.7686 12.4 9.09998ZM11.8 12.5C12.1313 12.5 12.4 12.2313 12.4 11.9C12.4 11.5686 12.1313 11.3 11.8 11.3H8.59998C8.2686 11.3 7.99998 11.5686 7.99998 11.9C7.99998 12.2313 8.2686 12.5 8.59998 12.5H11.8Z"
        fill="#8D9299"
      />
    </svg>
  );
};

export default IconCopy;
